module.exports = __webpack_public_path__ + "static/img/exploit3.1699b8e0.png";